import styled from "styled-components";
import { ButtonSettings, Text, Heading } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";

export const BuyAssetPageStyled = styled.section`
  width: 100%;
  height: 100%;
  position: relative;
  // text-align: center;
  display: flex;
  align-items: center;
  &::before {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    // background-color: #000;
    // opacity: 0.3;
    background: ${props => props.background && `url(${props.background}) no-repeat`};
    background-size: contain;
  }
`;

// export const PromotionContainerStyled = styled.article`
//   position: relative;
//   width: 80%;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;
//   border-radius: ${props => props.theme.font.size.default};
//   padding: ${props => props.theme.spacing.large} 0;
//   height: auto;
//   margin: 0 auto;
//   background-color: rgba(8, 33, 37, 0.97);
//   color: ${props => props.theme.color.white};
// `;

export const ButtonStyled = styled(ButtonSettings)`
  ${props =>
    props.displayBlock &&
    `
    display: block;
    margin: auto;
    margin-top: ${props.theme.spacing.medium};
    width: 35rem;
  `}
`;

export const LogoStyled = styled.div`
    position: absolute;
    ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "right")}: ${props =>
  props.theme.spacing.large};
    top: 2.5rem;
}
`;

export const LandingPageStyled = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: relative;
  text-align: center;
  background: ${props => props.background && `url(${props.background}) 0 0 / cover no-repeat`};
  padding: 0 3rem;
`;

export const TextContainer = styled.div`
  width: 90%;
  // margin: 0 auto;
`;

export const TextStyled = styled(Text)`
  font-weight: normal;
  font-size: 1.125rem;
  margin-top: 1rem;
  color: ${props => props.theme.color.greyLight};
  line-height: 1.2;
`;

export const BuyAssetContainer = styled.div`
  position: relative;
  width: 56%;
  border: 0.125rem solid rgba(209,211,212,0.3);
  border-radius: 0.5rem;
  // border-radius: ${props => props.theme.font.size.default};
  padding: 1.4rem 1.625rem;
  height: auto;
  margin-left: 2rem;
  // background-color: rgba(8, 33, 37, 0.97);
  background-color: rgba(0, 0, 0, 0.8);
  color: ${props => props.theme.color.white};
  box-shadow: 0 32px 48px 0 rgba(0, 0, 0, 0.5);
  margin-right: auto;

`;

export const HeadingSection = styled.div`
  // border-bottom: 1px solid rgba(255, 255, 255, 0.4);
`;

export const HeadingBorder = styled.div`
  height: 2px;
  width: 100%;
  opacity: 0.3;
  background-color: ${props => props.theme.color.greyLight};
  position: absolute;
  // margin: 1rem 0rem;
  ${props =>
    props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT
      ? `transform: translateX(2.8%)`
      : `transform: translateX(-2.8%)`};
  box-sizing: border-box;
`;

export const BodySection = styled.div`
  display: flex;
  justify-content: space-between;
  // padding-top: 1rem;
  padding: 1rem 0rem;
`;

export const FooterSections = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 1rem;
`;

export const FirstContainerStyle = styled.div`
  display: block;
  width: 31%;
  //  padding-left: 2rem;
`;
export const ImageStyle = styled.div`
  height: 12.577rem;
  width: 22.36rem;
  border-radius: 0.5rem;
  margin: 0 auto;
`;

export const DetailsContainerStyle = styled.div`
  width: 45%;
  text-align: ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")};
  // padding: 1rem;
  margin: auto 0;
`;

export const HeadingStyle = styled.div`
  display: flex;
  justify-content: space-between;
  // border-bottom: 1px solid rgba(255, 255, 255, 0.4);
`;

export const HeadingContentStyled = styled(Heading)`
  font-size: 2.474rem !important;
  font-weight: bold !important;
  width: 60%;
  margin: 0.67em 0 0;
`;
export const PriceStyled = styled(Heading)`
  font-size: 2.474rem !important;
  font-weight: bold !important;
  margin: 0.67em 0 0;
  color: #1ad1d3 !important;
`;

export const BorderDiv = styled.div`
  height: 2px;
  width: 100%;
  opacity: 0.3;
  background-color: ${props => props.theme.color.greyLight};
  margin: 1rem 0rem;
`;

export const TextDetailsStyled = styled(Text)`
  font-size: 1.75rem;
  padding-top: 2rem;
  margin-bottom: 1.8rem;
`;

export const StepContainer = styled.span`
  vertical-align: middle;
  width: 100%;
  margin-bottom: ${props => (props.userLocale === "ar" ? "0px" : props.theme.spacing.xsmall)};
  display: block;
  // margin-bottom: 1.8rem;
`;

export const StepNumber = styled.div`
  border-radius: 50%;
  display: inline-block;
  width: calc(3.918rem);
  height: calc(3.918rem);
  padding: 0.5rem ${props => props.theme.spacing.xsmall};
  // border: 3px solid rgba(${props => props.theme.color.primaryRGB}, 0.4);
  border: 2px solid rgba(209,211,212,0.16);
  background-color: #FFFFFF;
  // color: ${props => props.theme.color.white};
  color: #000000;
  text-align: center;
  font-size: 2.062rem;
  margin-${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right")}: 0.8rem;
`;

export const StepText = styled(Text)`
  vertical-align: middle;
  display: inline-block;
  // margin-bottom: ${props => props.theme.spacing.small};
  text-align: ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")};
  font-weight: bold;
  font-size: 1.443rem;
`;

export const QRCodeWrapper = styled.div`
  // margin-top: 13rem;

  svg {
    width: 21vw;
    height: 21vw;
    border: 0.8rem solid #fff;
    border-radius: ${props => props.theme.spacing.xsmall};
  }
`;

export const ButtonModelWrapper = styled.div`
  width: 35%;
  text-align: ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right")};
  margin: auto 0;
`;

export const ButtonModalStyled = styled(ButtonSettings)`
  // display: block;
  // margin-top: ${props => props.theme.spacing.xsmall};
  width: 100%;
  // margin-${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right: 72rem" : "left: 72rem")};
  // top: calc(-0.5rem * 3);
  position: relative;
`;

export const FooterTextStyled = styled(Text)`
  font-weight: normal;
  font-size: 1.5rem;
  // margin-top: 1rem;
  color: ${props => props.theme.color.greyLight};
  width: 55%;
  line-height: 1.2;
`;
